function FilterOptions(props) {
  return (
    <select
      name={props.label}
      className="form-select"
      aria-label={props.label}
      onChange={props.onChange}
      value={props.value}
    >
      <option value="All">All</option>
      {props.list.map((i) => (
        <option key={props.label + i} value={i}>
          {i}
        </option>
      ))}
    </select>
  );
}

export default FilterOptions;
